import Reactotron from 'reactotron-react-js'
// import { reactotronRedux } from 'reactotron-redux'

Reactotron
  .configure({
    name: process.env.REACT_APP_NAME,
    environment: process.env.NODE_ENV
  }) // we can use plugins here -- more on this later
  // .use(reactotronRedux())
  .connect() // let's connect!